import { ai } from "../../services/TelemetryService";

const trackEvent = (name, userProfile, eventSpecificProperties=null) => {
  const userProperties = !userProfile ? null : {
    user: userProfile.userName,
    terminal: userProfile.terminal.code || userProfile.terminal,
    planDate:userProfile.planDate,
  }
  
  ai &&
    ai.appInsights &&
    ai.appInsights.trackEvent({
      name:name,
      properties: {
        ...userProperties,
        ...eventSpecificProperties
      }
    });
};

export {trackEvent};
